import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Logo from "@/components/Logo";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@weighaway.co.uk");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("wa_admin_token", data.token);
      localStorage.setItem("wa_admin_email", data.email);
      toast.success("Welcome back");
      nav("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-black px-4">
      <form onSubmit={submit} className="wa-card w-full max-w-md" data-testid="admin-login-form">
        <Link to="/" className="flex items-center justify-center mb-4">
          <Logo size={72} />
        </Link>
        <h1 className="font-display text-2xl font-bold mb-4 text-white text-center">Admin login</h1>
        <div className="space-y-3">
          <div>
            <label className="wa-label">Email</label>
            <input className="wa-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
          </div>
          <div>
            <label className="wa-label">Password</label>
            <input className="wa-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
          </div>
          <button disabled={loading} className="wa-btn-primary w-full justify-center disabled:opacity-50" data-testid="admin-login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
}
